<!--
 * @Description: 查看json抽屉
 * @Date: 2022-04-27 11:20:59
 * @LastEditTime: 2023-05-16 17:29:37
-->
<template>
  <Drawer
    destroyOnClose
    title="物模型JSON"
    v-model:visible="visible"
    okText="关闭"
    @ok="handleOK"
    :get-container="false"
  >
    <json-viewer
      :value="showJson"
      :expand-depth="10"
      copyable
      boxed
      expanded
      :show-array-index="false"
    />
  </Drawer>
</template>
<script setup>
import { ref, defineExpose, defineProps } from "vue";
import Drawer from "@/components/model/drawer";
import JsonViewer from "vue-json-viewer";

const props = defineProps({
  record: Object
});
const showJson = ref({});
const visible = ref(false);
const open = (json) => {
  visible.value = true;
  showJson.value = json;
};
const close = () => {
  visible.value = false;
};

// 提交信息
const handleOK = () => {
  close();
};

defineExpose({
  open,
  close
});
</script>

<style lang="less" scoped>
.line {
  width: 100%;
  height: 1px;
  margin: 24px 0 16px;
  background: #f2f3f5;
}
:deep(.ant-btn.cancel) {
  display: none;
}
</style>
